import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'
import { Grid, IconButton, Paper, Stack } from '@mui/material'
import FormInput from 'components/FormInput'
import React from 'react'
import { Control, UseFieldArrayRemove } from 'react-hook-form'
import { HearingIdentificationType } from 'types/hearing-identification.type'
import { useHearingIdentificationBlockFieldsContext } from '../../../../../../../../contexts/hearing-identification-block-fields.context'

type SocialNetworkItemProps = {
  index: number
  control: Control<HearingIdentificationType>
  onRemove: UseFieldArrayRemove
}

export const SocialNetworkItem: React.FC<SocialNetworkItemProps> = ({
  index,
  control,
  onRemove,
}) => {
  const { isBlockedFields } = useHearingIdentificationBlockFieldsContext()

  return (
    <Paper variant='outlined' sx={{ ml: 2, mb: 2, p: 3, width: '100%' }}>
      <Grid container spacing={2}>
        <Grid item md={3} xs={12}>
          <FormInput
            control={control}
            name={`redesSociais.${index}.redeSocial`}
            label='Rede social'
            placeholder='Informe a rede social'
            maxLength={15}
            disabled={isBlockedFields}
          />
        </Grid>
        <Grid item md={9} xs={12}>
          <Stack spacing={1} direction='row'>
            <FormInput
              control={control}
              name={`redesSociais.${index}.descricao`}
              label='Descrição'
              maxLength={20}
              placeholder='Informe a descrição'
              disabled={isBlockedFields}
            />
            {index >= 1 && (
              <IconButton onClick={() => onRemove(index)}>
                <DeleteOutlineRoundedIcon color='error' />
              </IconButton>
            )}
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  )
}
